// src/quiz/greMocks.js
// GRE mocks beyond Mock 1 (which keeps its original routes). Routes, the
// dashboard card and the profile's mock tabs are all built from this map,
// so publishing a new mock only means adding it here.
import { greMock2 } from "./gre-mock2";
import { greMock3 } from "./gre-mock3";
import { greMock4 } from "./gre-mock4";
import { greMock5 } from "./gre-mock5";
import { greMock6 } from "./gre-mock6";

export const GRE_MOCKS = { 2: greMock2, 3: greMock3, 4: greMock4, 5: greMock5, 6: greMock6 };

const SECTION_PATHS = {
  verbal: "verbal-reasoning",
  quantitative: "quantitative-analysis",
  analytical: "analytical-writing",
};

export const greMockPath = (mock, section) => `/quiz/GRE/mock${mock}/${SECTION_PATHS[section]}`;
